// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as GraphqlClientCtx$LiteracyplanetClientFlags from "./GraphqlClientCtx.res.mjs";

function idleState(param) {
  return {
          loading: true,
          data: undefined,
          error: undefined
        };
}

var print = (function (q) {
    return q.definitions[0].name.value
  });

function Extend(Q) {
  var use = function (skip, variables) {
    var match = Curry._1(GraphqlClientCtx$LiteracyplanetClientFlags.use, undefined);
    var queryGraphqlAsync = match.queryGraphqlAsync;
    var match$1 = React.useState(function (param) {
          return {
                  loading: true,
                  data: undefined,
                  error: undefined
                };
        });
    var setResult = match$1[1];
    var result = match$1[0];
    var v = JSON.stringify(variables);
    var $$fetch = React.useCallback((async function (param) {
            if (result.loading) {
              
            } else {
              Curry._1(setResult, (function (r) {
                      return {
                              loading: true,
                              data: r.data,
                              error: r.error
                            };
                    }));
            }
            var match = await queryGraphqlAsync(Q.query, Curry._1(Q.serializeVariables, variables));
            var error = match.error;
            var data = match.data;
            return Curry._1(setResult, (function (param) {
                          return {
                                  loading: false,
                                  data: Belt_Option.map(data, (function (d) {
                                          return Curry._1(Q.parse, d);
                                        })),
                                  error: error
                                };
                        }));
          }), [
          skip,
          v
        ]);
    React.useEffect((function (param) {
            if (Belt_Option.getWithDefault(skip, false)) {
              Curry._1(setResult, (function (param) {
                      return {
                              loading: true,
                              data: undefined,
                              error: undefined
                            };
                    }));
            } else {
              Curry._1($$fetch, undefined);
            }
          }), [
          skip,
          v
        ]);
    return [
            result,
            $$fetch
          ];
  };
  var useFetch = function (param) {
    var match = Curry._1(GraphqlClientCtx$LiteracyplanetClientFlags.use, undefined);
    var queryGraphqlAsync = match.queryGraphqlAsync;
    return async function (variables) {
      var match = await queryGraphqlAsync(Q.query, Curry._1(Q.serializeVariables, variables));
      return {
              data: Belt_Option.map(match.data, (function (d) {
                      return Curry._1(Q.parse, d);
                    })),
              error: match.error
            };
    };
  };
  return {
          use: use,
          useFetch: useFetch
        };
}

var Query = {
  idleState: idleState,
  print: print,
  Extend: Extend
};

function Extend$1(M) {
  var use = function (param) {
    var match = Curry._1(GraphqlClientCtx$LiteracyplanetClientFlags.use, undefined);
    var queryGraphqlAsync = match.queryGraphqlAsync;
    return async function (variables) {
      var match = await queryGraphqlAsync(M.query, Curry._1(M.serializeVariables, variables));
      return {
              data: Belt_Option.map(match.data, (function (d) {
                      return Curry._1(M.parse, d);
                    })),
              error: match.error
            };
    };
  };
  var useWithState = function (param) {
    var mutate = use();
    var match = React.useState(function (param) {
          return {
                  called: false,
                  loading: false,
                  data: undefined,
                  error: undefined
                };
        });
    var setResult = match[1];
    var mutation = async function (variables) {
      Curry._1(setResult, (function (r) {
              return {
                      called: true,
                      loading: true,
                      data: r.data,
                      error: r.error
                    };
            }));
      var match = await Curry._1(mutate, variables);
      var res_data = match.data;
      var res_error = match.error;
      var res = {
        called: true,
        loading: false,
        data: res_data,
        error: res_error
      };
      Curry._1(setResult, (function (param) {
              return res;
            }));
      return res;
    };
    return [
            mutation,
            match[0]
          ];
  };
  return {
          use: use,
          useWithState: useWithState
        };
}

var Mutation = {
  Extend: Extend$1
};

function Extend$2(S) {
  var use = function (_variables) {
    return {
            loading: true,
            data: undefined,
            error: undefined
          };
  };
  return {
          use: use
        };
}

var Subscription = {
  Extend: Extend$2
};

export {
  Query ,
  Mutation ,
  Subscription ,
}
/* react Not a pure module */
